<template>
    <Head title="Welcome to RentRisk - RentRisk" />

    <GuestLayout>
        <div class="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8">
            <div class="max-w-2xl mx-auto">
                <div class="text-center">
                    <!-- RentRisk Logo -->
                    <div class="mx-auto flex items-center justify-center mb-6">
                        <JetAuthenticationCardLogoColored />
                    </div>

                    <!-- Success Message -->
                    <h1 class="text-3xl font-bold text-gray-900 mb-4">
                        Your account has successfully been created! Here's what you need to know:
                    </h1>

                    <!-- Success Items -->
                    <div class="bg-gray-50 rounded-lg p-6 mb-8 text-left">
                        <ul class="space-y-4">
                            <li class="flex items-start">
                                <div class="flex-shrink-0">
                                    <div class="flex items-center justify-center h-6 w-6 rounded-full bg-green-100">
                                        <svg class="h-4 w-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="ml-3">
                                    <p class="text-base font-medium text-gray-900">
                                        Account Created
                                    </p>
                                    <p class="text-sm text-gray-600 mt-1">
                                        Your account has been successfully created. You will receive an email to set your password and access your account. You'll also receive a welcome email from our Co-founder, Angie.
                                    </p>
                                </div>
                            </li>
                            
                            <li class="flex items-start">
                                <div class="flex-shrink-0">
                                    <div class="flex items-center justify-center h-6 w-6 rounded-full bg-green-100">
                                        <svg class="h-4 w-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="ml-3">
                                    <p class="text-base font-medium text-gray-900">
                                        Property Added
                                    </p>
                                    <p class="text-sm text-gray-600 mt-1">
                                        Your property has been added in your dashboard. You also have an email in your inbox with the property application link. Once you reset your password and access your account, you can manage features for each property there.
                                    </p>
                                </div>
                            </li>
                            
                            <li class="flex items-start">
                                <div class="flex-shrink-0">
                                    <div class="flex items-center justify-center h-6 w-6 rounded-full bg-green-100">
                                        <svg class="h-4 w-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                        </svg>
                                    </div>
                                </div>
                                <div class="ml-3">
                                    <p class="text-base font-medium text-gray-900">
                                        <template v-if="hasProtectSubscription">
                                            Subscription Active
                                        </template>
                                        <template v-else>
                                            Upgrade if Needed
                                        </template>
                                    </p>
                                    <p class="text-sm text-gray-600 mt-1">
                                        <template v-if="hasProtectSubscription">
                                            You're on a paid plan, which means you're taking fraud and risk prevention seriously. Login to setup each feature and start taking advantage of your subscription today!
                                        </template>
                                        <template v-else>
                                            You're on the free plan. You can start using all the basic features right away, and upgrade anytime to unlock additional features as you grow.
                                        </template>
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <!-- Action Button -->
                    <div class="flex flex-col sm:flex-row gap-4 justify-center">
                        <Link
                            :href="route('login')"
                            class="primaryButton text-base font-medium px-6 py-3"
                        >
                            Login
                        </Link>
                    </div>

                    <!-- Additional Info -->
                    <div class="mt-12 pt-8 border-t border-gray-200">
                        <p class="text-sm text-gray-500">
                            Didn't receive the welcome email? Check your spam folder or 
                            <a href="mailto:support@rentrisk.com" class="text-rent-risk-blue-400 hover:text-rent-risk-blue-400/80 underline">
                                contact support
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </GuestLayout>
</template>

<script setup>
import { Head, Link, usePage } from '@inertiajs/vue3'
import GuestLayout from '@/Layouts/V2/GuestLayout.vue'
import JetAuthenticationCardLogoColored from '@/Jetstream/AuthenticationCardLogoColored.vue'
import { computed } from 'vue'

const page = usePage()
const hasProtectSubscription = computed(() => page.props.hasProtectSubscription ?? false)
</script>

